import { render } from "./Language.vue?vue&type=template&id=07b6d0e6&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"

import "./Language.vue?vue&type=style&index=0&id=07b6d0e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b6d0e6"]])

export default __exports__